import { getBestRpcUrl } from './rpc';
import { getEnvironmentRpcUrl } from '@/utils/wallet-rpc';
import { NetworkType } from './types/rpc';

interface NetworkConfig {
  chainId: number;
  name: string;
  rpcUrl?: string;  
  currency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  explorer: string;
}

interface NetworkInfo {
  chainId: string;
  name: string;
  nativeSymbol: string;
  scannerName: string;
  dexName: string;
  pancakeUrl: string;
  explorerUrl: string;
}

export const NETWORKS: Record<string, NetworkInfo> = {
  BSC: {
    chainId: '0x38',
    name: 'BSC',
    nativeSymbol: 'BNB',
    scannerName: 'BscScan',
    dexName: 'PancakeSwap',
    pancakeUrl: 'https://pancakeswap.finance/info/pairs',
    explorerUrl: 'https://bscscan.com'
  },
  BSC_TESTNET: {
    chainId: '0x61',
    name: 'BSC Testnet',
    nativeSymbol: 'BNB',
    scannerName: 'BscScan',
    dexName: 'PancakeSwap',
    pancakeUrl: 'https://pancakeswap.finance/info/pairs',
    explorerUrl: 'https://testnet.bscscan.com'
  },
  OPBNB: {
    chainId: '0xcc',
    name: 'opBNB',
    nativeSymbol: 'BNB',
    scannerName: 'opBNBScan',
    dexName: 'PancakeSwap',
    pancakeUrl: 'https://pancakeswap.finance/info/pairs',
    explorerUrl: 'https://opbnbscan.com'
  },
  OPBNB_TESTNET: {
    chainId: '0x15eb',
    name: 'opBNB Testnet',
    nativeSymbol: 'BNB',
    scannerName: 'opBNBScan',
    dexName: 'PancakeSwap',
    pancakeUrl: 'https://pancakeswap.finance/info/pairs',
    explorerUrl: 'https://testnet.opbnbscan.com'
  },
  ETHEREUM: {
    chainId: '0x1',
    name: 'Ethereum',
    nativeSymbol: 'ETH',
    scannerName: 'Etherscan',
    dexName: 'Uniswap',
    pancakeUrl: 'https://app.uniswap.org/#/pools',
    explorerUrl: 'https://etherscan.io'
  },
  SEPOLIA: {
    chainId: '0xaa36a7',
    name: 'Sepolia',
    nativeSymbol: 'ETH',
    scannerName: 'Etherscan',
    dexName: 'Uniswap',
    pancakeUrl: 'https://app.uniswap.org/#/pools',
    explorerUrl: 'https://sepolia.etherscan.io'
  },
  AVALANCHE: {
    chainId: '0xa86a',
    name: 'Avalanche',
    nativeSymbol: 'AVAX',
    scannerName: 'Snowtrace',
    dexName: 'Trader Joe',
    pancakeUrl: 'https://traderjoexyz.com/pool',
    explorerUrl: 'https://snowtrace.io'
  },
  FUJI: {
    chainId: '0xa869',
    name: 'Avalanche Fuji',
    nativeSymbol: 'AVAX',
    scannerName: 'Snowtrace',
    dexName: 'Trader Joe',
    pancakeUrl: 'https://traderjoexyz.com/pool',
    explorerUrl: 'https://testnet.snowtrace.io'
  },
  ABSTRACT: {
    chainId: '0xab5',
    name: 'Abstract',
    nativeSymbol: 'ETH',
    scannerName: 'AbScan',
    dexName: 'Abstract DEX',
    pancakeUrl: 'https://app.abstract.xyz/pools',
    explorerUrl: 'https://abscan.org'
  },
  ABSTRACT_TESTNET: {
    chainId: '0x2b74',
    name: 'Abstract Sepolia',
    nativeSymbol: 'ETH',
    scannerName: 'AbScan',
    dexName: 'Abstract DEX',
    pancakeUrl: 'https://app.abstract.xyz/pools',
    explorerUrl: 'https://sepolia.abscan.org'
  },
  BASE: {
    chainId: '0x2105',
    name: 'Base',
    nativeSymbol: 'ETH',
    scannerName: 'BaseScan',
    dexName: 'Uniswap',
    pancakeUrl: 'https://app.uniswap.org/#/pools',
    explorerUrl: 'https://basescan.org'
  },
  BASE_SEPOLIA: {
    chainId: '0x14a34',
    name: 'Base Sepolia',
    nativeSymbol: 'ETH',
    scannerName: 'BaseScan',
    dexName: 'Uniswap',
    pancakeUrl: 'https://app.uniswap.org/#/pools',
    explorerUrl: 'https://sepolia.basescan.org'
  },
  OPTIMISM: {
    chainId: '0xa',
    name: 'OP Mainnet',
    nativeSymbol: 'ETH',
    scannerName: 'Optimistic Etherscan',
    dexName: 'Uniswap',
    pancakeUrl: 'https://app.uniswap.org/#/pools',
    explorerUrl: 'https://optimistic.etherscan.io'
  },
  OPTIMISM_SEPOLIA: {
    chainId: '0xaa37dc',
    name: 'OP Sepolia',
    nativeSymbol: 'ETH',
    scannerName: 'Optimistic Etherscan',
    dexName: 'Uniswap',
    pancakeUrl: 'https://app.uniswap.org/#/pools',
    explorerUrl: 'https://sepolia-optimism.etherscan.io'
  },
  ARBITRUM: {
    chainId: '0xa4b1',
    name: 'Arbitrum One',
    nativeSymbol: 'ETH',
    scannerName: 'Arbiscan',
    dexName: 'Uniswap',
    pancakeUrl: 'https://app.uniswap.org/#/pools',
    explorerUrl: 'https://arbiscan.io'
  },
  ARBITRUM_SEPOLIA: {
    chainId: '0x66eee',
    name: 'Arbitrum Sepolia',
    nativeSymbol: 'ETH',
    scannerName: 'Arbiscan',
    dexName: 'Uniswap',
    pancakeUrl: 'https://app.uniswap.org/#/pools',
    explorerUrl: 'https://sepolia.arbiscan.io'
  },
  POLYGON: {
    chainId: '0x89',
    name: 'Polygon',
    nativeSymbol: 'MATIC',
    scannerName: 'PolygonScan',
    dexName: 'QuickSwap',
    pancakeUrl: 'https://quickswap.exchange/#/pools',
    explorerUrl: 'https://polygonscan.com'
  },
  POLYGON_AMOY: {
    chainId: '0x13882',
    name: 'Polygon Amoy',
    nativeSymbol: 'MATIC',
    scannerName: 'PolygonScan',
    dexName: 'QuickSwap',
    pancakeUrl: 'https://quickswap.exchange/#/pools',
    explorerUrl: 'https://amoy.polygonscan.com'
  },
  SEI: {
    chainId: '0x531',
    name: 'Sei',
    nativeSymbol: 'SEI',
    scannerName: 'Seitrace',
    dexName: 'DragonSwap',
    pancakeUrl: 'https://dragonswap.app/pools',
    explorerUrl: 'https://seitrace.com'
  },
  SEI_TESTNET: {
    chainId: '0x530',
    name: 'Sei Atlantic',
    nativeSymbol: 'SEI',
    scannerName: 'Seitrace',
    dexName: 'DragonSwap',
    pancakeUrl: 'https://dragonswap.app/pools',
    explorerUrl: 'https://seitrace.com/?chain=atlantic-2'
  }
} as const;

const getRpcUrl = (network: NetworkType): string | undefined => {
  const mobileRpc = getEnvironmentRpcUrl(network);
  return mobileRpc ?? getBestRpcUrl(network);
};

export const networks = {
  mainnet: {
    chainId: 56,
    name: 'BSC Mainnet',
    rpcUrl: getRpcUrl('bsc'),
    currency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    explorer: 'https://bscscan.com',
  },
  testnet: {
    chainId: 97,
    name: 'BSC Testnet',
    rpcUrl: getRpcUrl('bscTestnet'),
    currency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    explorer: 'https://testnet.bscscan.com',
  },
  opbnb: {
    chainId: 204,
    name: 'opBNB',
    rpcUrl: 'https://opbnb-mainnet-rpc.bnbchain.org',
    currency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    explorer: 'https://opbnbscan.com',
  },
  opbnbTestnet: {
    chainId: 5611,
    name: 'opBNB Testnet',
    rpcUrl: 'https://opbnb-testnet-rpc.bnbchain.org',
    currency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    explorer: 'https://testnet.opbnbscan.com',
  },
  ethereum: {
    chainId: 1,
    name: 'Ethereum',
    rpcUrl: getRpcUrl('ethereum'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://etherscan.io',
  },
  sepolia: {
    chainId: 11155111,
    name: 'Sepolia',
    rpcUrl: getRpcUrl('sepolia'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://sepolia.etherscan.io',
  },
  avalanche: {
    chainId: 43114,
    name: 'Avalanche',
    rpcUrl: getRpcUrl('avalanche'),
    currency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18,
    },
    explorer: 'https://snowtrace.io',
  },
  fuji: {
    chainId: 43113,
    name: 'Avalanche Fuji',
    rpcUrl: getRpcUrl('fuji'),
    currency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18,
    },
    explorer: 'https://testnet.snowtrace.io',
  },
  abstract: {
    chainId: 2741,
    name: 'Abstract',
    rpcUrl: getRpcUrl('abstract'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://abscan.org',
  },
  abstractTestnet: {
    chainId: 11124,
    name: 'Abstract Sepolia',
    rpcUrl: getRpcUrl('abstractTestnet'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://sepolia.abscan.org',
  },
  base: {
    chainId: 8453,
    name: 'Base',
    rpcUrl: getRpcUrl('base'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://basescan.org',
  },
  baseSepolia: {
    chainId: 84532,
    name: 'Base Sepolia',
    rpcUrl: getRpcUrl('baseSepolia'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://sepolia.basescan.org',
  },
  optimism: {
    chainId: 10,
    name: 'OP Mainnet',
    rpcUrl: getRpcUrl('optimism'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://optimistic.etherscan.io',
  },
  optimismSepolia: {
    chainId: 11155420,
    name: 'OP Sepolia',
    rpcUrl: getRpcUrl('optimismSepolia'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://sepolia-optimism.etherscan.io',
  },
  arbitrum: {
    chainId: 42161,
    name: 'Arbitrum One',
    rpcUrl: getRpcUrl('arbitrum'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://arbiscan.io',
  },
  arbitrumSepolia: {
    chainId: 421614,
    name: 'Arbitrum Sepolia',
    rpcUrl: getRpcUrl('arbitrumSepolia'),
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    explorer: 'https://sepolia.arbiscan.io',
  },
  polygon: {
    chainId: 137,
    name: 'Polygon',
    rpcUrl: getRpcUrl('polygon'),
    currency: {
      name: 'Polygon',
      symbol: 'MATIC',
      decimals: 18,
    },
    explorer: 'https://polygonscan.com',
  },
  polygonAmoy: {
    chainId: 80002,
    name: 'Polygon Amoy',
    rpcUrl: getRpcUrl('polygonAmoy'),
    currency: {
      name: 'Polygon',
      symbol: 'MATIC',
      decimals: 18,
    },
    explorer: 'https://amoy.polygonscan.com',
  },
  sei: {
    chainId: 1329,
    name: 'Sei',
    rpcUrl: getRpcUrl('sei'),
    currency: {
      name: 'Sei',
      symbol: 'SEI',
      decimals: 18,
    },
    explorer: 'https://seitrace.com',
  },
  seiTestnet: {
    chainId: 1328,
    name: 'Sei Atlantic',
    rpcUrl: getRpcUrl('seiTestnet'),
    currency: {
      name: 'Sei',
      symbol: 'SEI',
      decimals: 18,
    },
    explorer: 'https://seitrace.com/?chain=atlantic-2',
  }
};

export function getNetworkById(id: string): NetworkConfig | undefined {
  return Object.values(networks).find(
    network => network.chainId.toString() === id
  );
}

export function getNetworkByChainId(chainId: number): NetworkConfig | undefined {
  return Object.values(networks).find(
    network => network.chainId === chainId
  );
}
